/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filter-item.selected[_ngcontent-%COMP%]{border:none;background-color:#4ea046}.filter-item.selected[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff}.filter-item.selected[_ngcontent-%COMP%]:hover   .filter-tooltip[_ngcontent-%COMP%]{top:48px}"];
export { styles as styles };
